import SVG from 'Components/SVG';
import { ROUTES, SVG_TYPE } from 'Shared/enums';
import { MainType } from './Container';
import Button from 'Components/Button';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Back from 'Components/Back';

function RestorePasswordPage(props: MainType) {
  const { actions, authorisedUser } = props;
  const { setIsNaviagtionHidden } = actions;
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);
  const variant = query.get('variant');

  const onSubmit = () => {
    navigate(ROUTES.RESTORE_PASSWORD);
  };

  useEffect(() => {
    setIsNaviagtionHidden(true);
    return () => {
      setIsNaviagtionHidden(false);
    };
  }, []);

  useEffect(() => {
    authorisedUser && (setIsNaviagtionHidden(true), navigate(ROUTES.DASHBOARD_ORDERS));
  }, [authorisedUser]);

  return (
    <div className="page restore-password">
      <span className="restore-password__box"></span>
      <div className="restore-password__wrapper">
        <Back onClick={() => navigate(ROUTES.LOGIN_PAGE)} className="restore-password__back" />
        <SVG type={SVG_TYPE.LOGO} />
        <h2 className="restore-password__title">Ten link wygasł</h2>
        <p className="restore-password__subtitle">
          {variant === 'activate'
            ? 'Aby aktywować konto zgłoś się do administratora z prośbą o ponowne wysłanie linku aktywacyjnego.'
            : 'Aby zresetować hasło wyślij prośbę ponownie.'}
        </p>
        {variant === 'reset' ? <Button label="Wyślij" type="submit" onClick={() => onSubmit()} round /> : null}
      </div>
      <SVG type={SVG_TYPE.RESTORE_PASSWORD} className="restore-password__svg" />
    </div>
  );
}

export default RestorePasswordPage;
